import {
  ApplicationRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { EventSocketService } from './../../services/event-socket.service';
import { MapServicesService } from 'src/app/map/services/map-services.service';
import { EventService } from '../../services/event.service';
import { ReferenceService } from '../../services/reference.service';
import { ConnectionService } from '../../services/connection.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SliderMultimediaComponent } from 'src/app/shared/components/slider-multimedia/slider-multimedia.component';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { Alert, Evaluation } from 'src/app/alerts/models/alert.interface';
import { ToastService } from 'src/app/shared/services/toast.service';
import {
  Subject,
  Subscription,
  from,
  BehaviorSubject,
  Observable,
  of,
} from 'rxjs';
import { ComunicationService } from 'src/app/shared/services/comunication.service';
import { CustomToastMessagessService } from 'src/app/map/services/custom-toast-messagess.service';
import { WaitTimeService } from '../../services/wait-time.service';
import { Vehicle, VehicleList } from 'src/app/vehicles/models/vehicle';
import { OperatorService } from 'src/app/shared/services/operator.service';
import { WhatsappService } from '../../services/whatsapp.service';
import { EventTx } from '../../models/interfaces';
import { DvrGalleryComponent } from '../dvr-gallery/dvr-gallery.component';
import { EvaluationCriteriaService } from '../../services/evaluation-criteria.service';
import * as L from 'leaflet';
import {
  takeUntil,
  tap,
  catchError,
  map,
  switchMap,
  take,
} from 'rxjs/operators';
import { MapAsideService } from 'src/app/panel/components/map-aside/service/map-aside.service';
import { ValueInputsDisabled } from 'src/app/panel/components/map-aside/components/events-content/models/event-content.model';
import { IsReloadPageService } from 'src/app/vehicles/components/content-panel-vehicles/service/is-reload-page.service';
import { normalizeEvaluations } from 'src/app/panel/components/map-aside/components/events-content/helpers/normalize-evaluations';
import { event } from 'jquery';
import { ChecklistEventService } from '../../services/checklist-event.service';
import { WhatsAppResponse } from '../../models/interfaces';
import { DriverIdentificationService } from 'src/app/drivers/driver-identification/services/driver-identification.service';

import { PermissionService } from 'src/app/permiss/permission.service';
import * as moment from 'moment';

interface Data {
  alert: Alert;
  htmlElement: HTMLElement;
}

interface EventSelectionData {
  event: any;
  currentRow?: HTMLElement;
}

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventListComponent implements OnInit, OnDestroy {
  private subscription!: Subscription;
  tipoEvento: any = [];
  selectedEvent: any[] = [];
  activeEvent: any = false;
  noResults: boolean = false;
  expanded: boolean = false;

  isLoadingMoreEvents: boolean = false;
  canLoadMoreEvents: boolean = true;

  public uuid_evaluation: any = [];
  public events: any[] = [];

  public imei_debug: string = '864200050708453';
  public data_debug: any = ['-', '-', '-', '-'];
  evaluation_criteria_filter: any[] = [];
  list_events_slug_criteria = [
    'conductor-adormitado-360',
    'conductor-somnoliento-360',
    'posible-fatiga',
    'conductor-distraido-360',
    'cinturon-desabrochado-360',
    'conductor-fumando-360',
  ];
  evaluation_criteria = [];

  operators = [
    {
      label: 'Operadores',
      items: [
        {
          label: 'ATENCIO ALFARO, Claudia Isabel',
          value: 'ATENCIO ALFARO, Claudia Isabel',
        },
        {
          label: 'FERNANDEZ CRUZ, Rosellia Yanina',
          value: 'FERNANDEZ CRUZ, Rosellia Yanina',
        },
        {
          label: 'HAÑARI SALCEDO, Katherine Liliana',
          value: 'HAÑARI SALCEDO, Katherine Liliana',
        },
        { label: 'MAMANI SIERRA, Raquel', value: 'MAMANI SIERRA, Raquel' },
        {
          label: 'NUÑEZ CHAMBI, Michelle Solzire',
          value: 'NUÑEZ CHAMBI, Michelle Solzire',
        },
        {
          label: 'NUÑONCA ALARCON, Daniela Stefany',
          value: 'NUÑONCA ALARCON, Daniela Stefany',
        },
        {
          label: 'PACCI QUISPE, Betzy Belquis',
          value: 'PACCI QUISPE, Betzy Belquis',
        },
        {
          label: 'PACHECO MOLLO, Cesar Vidal',
          value: 'PACHECO MOLLO, Cesar Vidal',
        },
        {
          label: 'ROJAS RONDON, Carla Beatriz',
          value: 'ROJAS RONDON, Carla Beatriz',
        },
        {
          label: 'SUARES PACURI, Ayelen Melani',
          value: 'SUARES PACURI, Ayelen Melani',
        },
      ],
    },
  ];
  currentRowSelected!: HTMLElement;
  display_dialog_event: boolean = false;
  display_dialog_content_event: boolean = true;
  eventsEvaluated: number = 0;
  sendEvaluationByWhatsapp: boolean = false;
  sendExternal: boolean = false;

  vehiclesList: VehicleList[] = [];
  selectedVehicles: VehicleList[] = [];

  operations: any[] = [];
  selectedOperation: any;
  groups: any[] = [];
  selectedGroup: any;
  convoys: any[] = [];
  selectedConvoy: any;

  placeholderOperation = 'Seleccione una Operación ...';
  placeholderGroup = 'Seleccione una Operación Primero...';
  placeholderConvoy = 'Seleccione un Grupo Primero...';

  disabledOperation = false;
  disabledGroup = true;
  disabledConvoy = true;

  public showSearchPanel: boolean = false;
  public searchStartDate: Date = new Date();
  public searchEndDate: Date = new Date();
  public minSearchDate: Date = new Date();
  public maxSearchDate: Date = new Date();
  public showDateRangeWarning: boolean = false;

  onHide() {
    this.display_dialog_event = true;
    if (this.display_dialog_event) {
      if (this.display_dialog_content_event) {
        this.display_dialog_content_event = false;
      } else {
        this.display_dialog_content_event = true;
      }
    }
  }

  loading_evaluation = false;
  expandedRows: { [s: string]: boolean } = {};
  submitting = false;
  private onDestroy$ = new Subject<boolean>();

  // Agregar estos Subjects
  private eventSelection$ = new Subject<{
    event: any;
    currentRow?: HTMLElement;
  }>();
  private rowExpansion$ = new Subject<any>();
  private isErrorEventEvaluated: boolean = false;
  private lastMultimediaComponentRef: any;

  constructor(
    public evaluationCriteriaService: EvaluationCriteriaService,
    public eventService: EventService,
    public referenceService: ReferenceService,
    public connectionService: ConnectionService,
    public mapService: MapServicesService,
    public eventSocketService: EventSocketService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef,
    private vehicleService: VehicleService,
    private toastService: ToastService,
    private comunicationService: ComunicationService,
    private customToastMessagess: CustomToastMessagessService,
    private appRef: ApplicationRef,
    private waitTimeService: WaitTimeService,
    private operatorService: OperatorService,
    private whatsappService: WhatsappService,
    private cdr: ChangeDetectorRef,
    private mapAsideService: MapAsideService,
    private reloadPageService: IsReloadPageService,
    private checklistEventService: ChecklistEventService,
    private driverIdentificationService: DriverIdentificationService,
    private permissionService: PermissionService,
  ) {
    this.subscription = comunicationService.event$.subscribe((data: Data) => {
      // data.htmlElement.click();
      document.getElementById(data.alert.uuid_event)?.click();
      this.cdr.detectChanges();
    });
    // this.tipoEvento = [
    //   { id: 0, option: 'Todos los Eventos', tipo: '' },
    //   { id: 1, option: 'Alcoholemia', tipo: '' },
    //   { id: 2, option: 'Somnolencia', tipo: 'Somnolencia', clase: 'somnolencia' },
    //   { id: 3, option: 'Distracción', tipo: 'Distraccion', clase: 'distraccion' },
    //   { id: 4, option: 'Batería Desconectada', tipo: 'Bateria desconectada', clase: 'bateria-desconectada' },
    //   { id: 5, option: 'Aceleración Brusca', tipo: 'Aceleracion brusca', clase: 'aceleracion-brusca' },
    //   { id: 6, option: 'Frenada Brusca', tipo: 'Frenada brusca', clase: 'frenada-brusca' },
    //   { id: 7, option: 'S.O.S.', tipo: 'SOS', clase: 'sos-event' },
    //   { id: 8, option: 'Zona de Entrada', tipo: 'Zona de entrada', clase: 'zona-entrada' },
    //   { id: 9, option: 'Zona de Salida', tipo: 'Zona de salida', clase: 'zona-salida' },
    //   { id: 10, option: 'Tiempo de estadía en zona', tipo: 'Tiempo de estadia en zona', clase: 'tiempo-estadia-zona' },
    //   { id: 11, option: 'Parada en zona no autorizada', tipo: 'Parada en zona no autorizada', clase: 'parada-zona-no-autorizada' },
    //   { id: 12, option: 'Exceso de velocidad', tipo: 'Exceso de Velocidad', clase: 'exceso-velocidad' },
    //   { id: 13, option: 'Transgresión', tipo: '' },
    //   { id: 14, option: 'Infracción', tipo: 'Infraccion', clase: 'infraccion' },
    //   { id: 15, option: 'Vehículo sin programación', tipo: 'Vehiculo sin programacion', clase: 'vehiculo-sin-programacion' },
    //   { id: 16, option: 'Mantenimiento preventivo', tipo: 'Mantenimiento preventivo', clase: 'mantenimiento-preventivo' },
    //   { id: 16, option: 'Mantenimiento preventivo realizado', tipo: 'Mantenimiento preventivo realizado', clase: 'mantenimiento-preventivo-realizado' },
    //   { id: 17, option: 'Mantenimiento correctivo', tipo: 'Mantenimiento correctivo', clase: 'mantenimiento-correctivo' },
    //   { id: 18, option: 'Mantenimiento correctivo realizado', tipo: 'Mantenimiento correctivo realizado', clase: 'mantenimiento-correctivo-realizado' },
    //   { id: 19, option: 'Motor apagado', tipo: 'Motor apagado', clase: 'motor-apagado' },
    //   { id: 20, option: 'Motor encendido', tipo: 'Motor encendido', clase: 'motor-encendido' },
    //   { id: 21, option: 'Fatiga', tipo: 'Fatiga', clase: 'fatiga' },
    //   { id: 22, option: 'Posible Fatiga', tipo: 'Posible Fatiga', clase: 'posible-fatiga' },
    //   { id: 23, option: 'Fatiga Extrema', tipo: 'Fatiga Extrema', clase: 'fatiga-extrema' },
    //   { id: 24, option: 'Desvío de carril hacia la izquierda', tipo: 'Desvío de carril hacia la izquierda', clase: 'desvio-carril-izq' },
    //   { id: 25, option: 'Desvío de carril hacia la derecha', tipo: 'Desvío de carril hacia la derecha', clase: 'desvio-carril-der' },
    //   { id: 26, option: 'Bloqueo de visión del Mobileye', tipo: 'Bloqueo de visión del mobileye', clase: 'bloqueo-vision-mobileye' },
    //   { id: 27, option: 'Colisión con peatones', tipo: 'Colisión con peatones', clase: 'colision-peatones' },
    //   { id: 28, option: 'Colisión con delantera', tipo: 'Colisión delantera', clase: 'colision-delantera' },
    //   { id: 29, option: 'Bloqueo de visión del mobileye', tipo: 'Bloqueo de visión del mobileye', clase: 'bloqueo-vision-mobileye' },
    // ];
  }

  private isLoadingForm = false;
  public events$ = new Observable<any[]>();
  private auxServiceNext: boolean = true;
  private auxServicePrevious: boolean = true;
  /**
   * @deprecated
   * Deprecated: Clear date filter
   */
  /*
  clearDateFilter() {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    this.startDate = yesterday;
    this.endDate = today;
    this.startDate = yesterday;
    this.endDate = today;
    this.eventService.filterByDatePublic(yesterday, today);
    this.filterByDate();
    this.showDateFilter = false;
    this.cdr.detectChanges();
  }
  */

  private eventsTable: any[] = [];
  private originEvents: any[] = [];
  eventClasses: Record<string, string> = {};

  async ngOnInit() {
    if (this.eventService.searchStartDate)
      this.searchStartDate = this.eventService.searchStartDate;
    if (this.eventService.searchEndDate)
      this.searchEndDate = this.eventService.searchEndDate;

    this.events$ = this.eventService.filteredEvents$.pipe(
      tap((events) => {
        // console.log("ENTRE: " + events)
        this.eventsTable = events;
        events.forEach((event) => {
          const uuid = event.uuid_event;
          if (!this.eventClasses[uuid]) {
            this.eventClasses[uuid] = this.calculateInitialClass(event);
          }
        });
      }),
    );

    /* Deprecated: Initial filter applying
    // Initial filter applying
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    this.startDate = yesterday;
    this.endDate = today;

    // Ensure service has initial values
    this.eventService.filterByDatePublic(yesterday, today);
    */

    this.checklistEventService.checklistEvents$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((checklists) => {
        // console.log(checklists, "update checklist evnet list clases")
        for (const [uuid, checklist] of Object.entries(checklists)) {
          this.eventClasses[uuid] = checklist.clase;
        }
        this.cdr.detectChanges();
      });

    this.eventService.getEvents
      .pipe(
        takeUntil(this.onDestroy$),
        tap((event) => (this.originEvents = event)),
      )
      .subscribe();

    this.mapAsideService.getNextEvent
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((_) => {
        if (this.auxServiceNext) {
          this.auxServiceNext = false;
          return;
        }
        if (this.currentRowSelected && this.eventsTable.length > 0) {
          const uuid_event = this.currentRowSelected
            .getAttribute('id')
            ?.replace('event-', '');
          const idEvent = this.eventsTable.findIndex(
            (event) => event.uuid_event == uuid_event,
          );
          const idEventPost = idEvent > 0 ? idEvent - 1 : 0;
          const eventPost = this.eventsTable[idEventPost];
          const elementEventPost = document.getElementById(
            'event-' + eventPost.uuid_event,
          );
          if (elementEventPost) {
            this.currentRowSelected = elementEventPost;
            this.rowExpandend({ data: eventPost });
            this.switchEventOnMap(eventPost, elementEventPost);
          }
        }
      });

    this.mapAsideService.getPreviousEvent
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((_) => {
        if (this.auxServicePrevious) {
          this.auxServicePrevious = false;
          return;
        }
        if (this.currentRowSelected && this.eventsTable.length > 0) {
          const uuid_event = this.currentRowSelected
            .getAttribute('id')
            ?.replace('event-', '');
          const idEvent = this.eventsTable.findIndex(
            (event) => event.uuid_event == uuid_event,
          );
          const lenghtMax = this.eventsTable.length;
          const idEventPrevious =
            idEvent < lenghtMax - 1 ? idEvent + 1 : lenghtMax - 1;
          const eventPrevious = this.eventsTable[idEventPrevious];
          const elementEventPrevious = document.getElementById(
            'event-' + eventPrevious.uuid_event,
          );
          if (elementEventPrevious) {
            this.currentRowSelected = elementEventPrevious;
            this.rowExpandend({ data: eventPrevious });
            this.switchEventOnMap(eventPrevious, elementEventPrevious);
          }
        }
      });

    this.mapAsideService.sendEvaluationByWhatsapp$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((state) => {
        this.submitSendEvaluationByWhatsapp(state);
      });

    this.mapAsideService.sendExternal$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((state) => {
        this.submitSendExternal(state);
      });

    this.mapAsideService.submitFormEventContent$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(({ body, event }) => {
        if (body !== undefined && event !== undefined) {
          const _: any = '';
          this.submitEvaluation(body, event, this.currentRowSelected);
          this.mapAsideService.setSubmitFormEventContent(undefined, undefined);
        }
      });

    this.mapAsideService.isLoading$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((isLoading) => {
        this.isLoadingForm = isLoading;
      });

    this.evaluationCriteriaService
      .initEvaluationCriteria()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        this.cdr.detectChanges();
      });

    // console.log("event list on init ========================================================================");
    this.selectedEvent = await this.eventService.getEventSelected();
    //console.log('seleccionEventos: ', this.selectedEvent);

    this.selectedVehicles = await this.eventService.getVehicleSelected();
    //console.log('seleccionVehicles: ', this.selectedVehicles);
    // this.connectionService.monitor();

    this.selectedOperation = await this.eventService.getOperationSelected();
    this.selectedGroup = await this.eventService.getGroupSelected();
    this.selectedConvoy = await this.eventService.getConvoySelected();

    if (!this.eventService.eventsLoaded || !this.eventService.filterLoaded) {
      this.spinner.show('loadingEventList');
      //console.log('cargandoeventos:', this.eventService.eventsLoaded);
    }
    this.loadFilterData();

    /* const storedFilter = localStorage.getItem('filter') || '';
    this.selectedEvent = storedFilter ? [{ value: storedFilter }] : []; */

    this.eventService.debugEventStream
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((res) => {
        //console.log('desde event list -> debugEventStream res: ', res);
        this.data_debug = res.data;
        this.cdr.detectChanges();
      });
    this.eventService.evaluationEventStream
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((info) => {
        //console.log('desde event list -> evaluationEventStream info: ', info);
        // this.data_debug = res.data;
        this.eventService.integrateEvaluationEvent(info);
        this.cdr.detectChanges();
      });
    this.eventService.newEventStream
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        // console.log("desde event list ",res);
        // this.searchByPlate();
        this.changeTypeEvent();
        this.filterByVehicles();
        this.cdr.detectChanges();
      });

    this.referenceService.searchReferenceEventCompleted
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((event) => {
        this.showEvent(event);
        this.cdr.detectChanges();
      });

    // EN ESPERA DE USAR OPERADORES DE PANEL ADMIN
    if (this.operatorService.stateOperators == false) {
      this.spinner.show('loadingOperators');
      this.operatorService.initialize();
      this.operatorService.dataComplete
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          async (operators) => {
            //console.log('OPERADORES OBTENIDOS: 1 vez', operators);
            this.operators = this.setListOperators();
            this.spinner.hide('loadingOperators');
            this.cdr.detectChanges();
          },
          (error) => {
            this.spinner.hide('loadingOperators');
            console.error(
              'Error al obtener los Operadores de Monitoreo:',
              error,
            );
          },
        );
    } else {
      this.spinner.show('loadingOperators');
      //console.log('OPERADORES LOADED');
      this.operators = this.setListOperators();
      this.spinner.hide('loadingOperators');
      this.cdr.detectChanges();
    }

    if (this.eventService.eventsUserLoaded == false) {
      try {
        const data = await this.eventService.getEventsForUser().toPromise();
        //console.log('EVENTOS DEL USUARIO OBTENIDOS:', data);
        if (data.success) {
          this.eventService.createEventList(data.data);
        } else {
          //console.log('EL USUARIO NO TIENE EVENTOS');
        }
      } catch (error) {
        console.error('Error al obtener los eventos:', error);
      } finally {
        this.spinner.hide('loadingEventList');
        this.reloadPageService.checkOpenPanelEvents();
      }
    } else {
      this.spinner.hide('loadingEventList');
      this.reloadPageService.checkOpenPanelEvents();
      // this.spinner.show('loadingHistorialForm');
      // this.spinner.hide('loadingHistorialForm');
    }

    this.cdr.detectChanges();

    /* carga anterior de los eventons */
    // if (this.eventService.eventsUserLoaded == false) {
    //   //this.spinner.show('loadingEventsPanel');
    //   this.eventService.getEventsForUser().subscribe(
    //     async (data) => {
    //       // Aquí puedes trabajar con los datos obtenidos
    //       console.log('EVENTOS DEL USUARIO OBTENIDOS:', data);
    //       // Realiza cualquier acción con los datos recibidos
    //       if (data.success) {
    //         this.eventService.createEventList(data.data);
    //       } else {
    //         console.log('EL USUARIO NO TIENE EVENTOS');
    //       }
    //       this.spinner.hide('loadingEventsPanel');
    //     },
    //     (error) => {
    //       // Maneja los errores si ocurre alguno durante la solicitud
    //       console.error('Error al obtener los eventos:', error);
    //     }
    //   );
    // } else {
    //   this.spinner.show('loadingHistorialForm');
    //   // console.log(
    //   //   'TEST IN EVENTS PANEL->',
    //   //   this.eventService.eventsGroupedList
    //   // );
    //   this.spinner.hide('loadingHistorialForm');
    // }
    await this.changeTypeEvent();

    if (this.vehicleService.statusDataVehicle) {
      this.spinner.show('loadingVehiculos');
      try {
        if (!this.eventService.config.showGroupingSelector) {
          await this.generateVehicleList();
        }
      } catch (error) {
        console.error('Error al generar la lista de vehículos:', error);
      } finally {
        this.spinner.hide('loadingVehiculos');
        this.updateDropdowns(false);
        this.cdr.detectChanges();
      }
    } else {
      this.spinner.show('loadingVehiculos');
      this.vehicleService.vehicleCompleted
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(async (status) => {
          try {
            if (!this.eventService.config.showGroupingSelector) {
              await this.generateVehicleList();
            }
            this.cdr.detectChanges();
          } catch (error) {
            console.error('Error al generar la lista de vehículos:', error);
          } finally {
            this.spinner.hide('loadingVehiculos');
            this.updateDropdowns(false);
            this.cdr.detectChanges();
          }
        });
    }

    // Configurar el stream de selección de eventos
    this.eventSelection$
      .pipe(
        takeUntil(this.onDestroy$),
        switchMap(({ event, currentRow }: EventSelectionData) => {
          this.waitTimeService.startTime({
            id: event.uuid_event,
            start: Date.now(),
            itemsId: [],
            end: [],
            event: [],
            type: [],
            size: [],
            duration: [],
          });

          return from(
            this.switchTypeEventFilter(event.evento || event.tipo),
          ).pipe(
            switchMap(() => {
              document
                .getElementById(event.uuid_event)
                ?.classList?.add('watched-event');
              return from(
                this.eventService.getReference(event.latitud, event.longitud),
              ).pipe(
                map((_) => ({
                  event: {
                    ...event,
                    referencia: { ..._ }.referencia,
                    evaluation_criteria_filter: this.evaluation_criteria_filter,
                    operators: this.operatorService.listOperators,
                  },
                  currentRow,
                })),
                catchError((error) => {
                  console.error('Error al obtener referencia:', error);
                  return of({
                    event: {
                      ...event,
                      referencia: 'Esperando respuesta del servidor, 1 minuto',
                      evaluation_criteria_filter:
                        this.evaluation_criteria_filter,
                      operators: this.operatorService.listOperators,
                    },
                    currentRow,
                  });
                }),
              );
            }),
          );
        }),
      )
      .subscribe(({ event, currentRow }) => {
        this.showEvent(event);
        this.currentRowSelected = currentRow!;
        if (this.isErrorEventEvaluated) {
          this.rowExpandend({ data: event });
          this.isErrorEventEvaluated = false;
        }
      });

    // Configurar el stream de expansión de filas
    this.rowExpansion$
      .pipe(
        takeUntil(this.onDestroy$),
        switchMap((event) => {
          this.isRegisterEvent = false;
          if (!event.data?.uuid_event) {
            this.loading_evaluation = false;
            this.display_dialog_event = false;
            this.mapAsideService.setValueAuxDisabled(false, null);
            return of({ evaluations: [], eventData: event.data });
          }
          this.expandedRows[event.data.uuid_event] =
            !this.expandedRows[event.data.uuid_event];
          this.loading_evaluation = true;
          this.display_dialog_event = true;
          this.display_dialog_content_event = true;
          this.cdr.detectChanges();

          /* return of({
            evaluations: normalizeEvaluations(event.data.evaluations),
            eventData: event.data,
          }); */

          let parametrosObj: any = {};
          if (
            event.data.parametros &&
            typeof event.data.parametros == 'string'
          ) {
            event.data.parametros.split('|').forEach((item: any) => {
              const [key, value] = item.split('=');
              parametrosObj[key] = value;
            });
          }
          return from(
            this.eventService.getEvaluations(event.data.uuid_event, {
              'tracker-date': parametrosObj.eventDateTime ?? undefined,
            }),
          ).pipe(
            map((evaluations) => ({
              evaluations,
              eventData: {
                ...event.data,
                driver_id:
                  evaluations[0]?.driver_id?.toString() ??
                  event.data.driver_id ??
                  '0',
              },
            })),
            catchError((error) => {
              return of({
                evaluations: [], // Retorna array vacío en caso de error
                eventData: event.data,
                error: true,
              });
            }),
          );
        }),
      )
      .subscribe({
        next: (response) => {
          const { evaluations, eventData } = response;
          if ('error' in response && response.error) {
            this.mapAsideService.setValueAuxDisabled(false, null, true);
            this.loading_evaluation = false;
            this.cdr.detectChanges();
            return;
          }

          if (
            evaluations &&
            evaluations.length > 0 &&
            !evaluations[0]['is_empty']
          ) {
            let auxEvent = this.eventService.eventsFiltered.find(
              (ev: any) => ev.uuid_event == eventData.uuid_event,
            );
            if (auxEvent) {
              auxEvent.evaluations = evaluations as Evaluation[];
              auxEvent.evaluated = eventData.evaluated;
              auxEvent.driver_id = eventData.driver_id;
              this.isRegisterEvent =
                eventData.evaluated === 1 || (evaluations[0].id ? true : false);
              this.valueInputsDisabled = {
                criteria_name:
                  evaluations[0].criterio_evaluacion || 'No hay criterios',
                url_video: evaluations[0].identificacion_video,
                calification:
                  typeof evaluations?.[0]?.valoracion_evento === 'string'
                    ? evaluations[0].valoracion_evento
                    : evaluations?.[0]?.valoracion_evento != null
                      ? evaluations[0].valoracion_evento.toString()
                      : '0',
                observation: evaluations[0].observacion_evaluacion,
                operator_name: evaluations[0].operador_monitoreo,
                comunication: evaluations[0].has_radio_communication,
              };
            }

            this.mapAsideService.setValueAuxDisabled(
              this.isRegisterEvent,
              this.valueInputsDisabled,
            );
          } else {
            this.isRegisterEvent = false;
            this.mapAsideService.setValueAuxDisabled(false, null);
          }

          this.loading_evaluation = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error processing row expansion:', error);
          this.loading_evaluation = false;
          this.cdr.detectChanges();
        },
      });
  }

  private updateDropdowns(resetSelection: boolean = true) {
    const allVehicles = this.vehicleService.vehicles || [];

    // 1. Operations are always computed from all vehicles
    this.operations = this.getUniqueOptions(allVehicles, 'idoperation', [
      'nameoperation',
      'operation',
    ]);
    this.disabledOperation = false;

    // 2. Filter step 1: by Operation
    let vehiclesFilteredByOp = allVehicles;
    if (this.selectedOperation != null) {
      vehiclesFilteredByOp = allVehicles.filter(
        (v) => v.idoperation === this.selectedOperation,
      );

      this.groups = this.getUniqueOptions(vehiclesFilteredByOp, 'idgrupo', [
        'namegrupo',
        'grupo',
      ]);
      this.disabledGroup = false;
      this.placeholderGroup = 'Seleccione un Grupo...';
    } else {
      this.groups = [];
      this.selectedGroup = null;
      this.disabledGroup = true;
      this.placeholderGroup = 'Seleccione una Operación Primero...';
    }

    // 3. Filter step 2: by Group
    let vehiclesFilteredByGroup = vehiclesFilteredByOp;
    if (this.selectedGroup != null) {
      vehiclesFilteredByGroup = vehiclesFilteredByOp.filter(
        (v) => v.idgrupo === this.selectedGroup,
      );

      this.convoys = this.getUniqueOptions(
        vehiclesFilteredByGroup,
        'idconvoy',
        ['nameconvoy'],
      );
      this.disabledConvoy = false;
      this.placeholderConvoy = 'Seleccione un Convoy...';
    } else {
      this.convoys = [];
      this.selectedConvoy = null;
      this.disabledConvoy = true;
      this.placeholderConvoy = 'Seleccione un Grupo Primero...';
    }

    // 4. Filter step 3: by Convoy
    let finalFilteredVehicles = vehiclesFilteredByGroup;
    if (this.selectedConvoy != null) {
      finalFilteredVehicles = vehiclesFilteredByGroup.filter(
        (v) => v.idconvoy === this.selectedConvoy,
      );
    }

    // 5. Update the available vehicles list
    this.populateVehiclesList(finalFilteredVehicles);

    if (resetSelection) {
      this.selectedVehicles = [...this.vehiclesList];
    }

    this.filterByVehicles();
  }

  private getUniqueOptions(vehicles: any[], idKey: string, nameKeys: string[]) {
    const uniqueMap = new Map();
    for (const v of vehicles) {
      const id = v[idKey];
      if (id != null && !uniqueMap.has(id)) {
        let name = '';
        for (const key of nameKeys) {
          if (v[key]) {
            name = v[key];
            break;
          }
        }
        uniqueMap.set(id, { [idKey]: id, [nameKeys[0]]: name });
      }
    }
    return Array.from(uniqueMap.values()).sort(
      (a, b) => (a[idKey] || 0) - (b[idKey] || 0),
    );
  }

  calculateInitialClass(event: any): string {
    if (event.evento === 'checklist-daily') {
      return (
        this.checklistEventService.getChecklistEvent(event.uuid)?.clase ||
        'checklist-waiting'
      );
    }
    if (
      [
        'exceso-velocidad-nivel',
        'exceso-velocidad-nivel-direccion',
        'exceso-velocidad-duracion-direccion',
      ].includes(event.tipo)
    ) {
      const lvlss = [
        { value: 'Nivel III', lvl: '-lvl3' },
        { value: 'Nivel II', lvl: '-lvl2' },
        { value: 'Nivel I', lvl: '-lvl1' },
      ];
      const _lvl = lvlss.find((lvl) => event.nombre.includes(lvl.value));
      if (_lvl) {
        event.tipo += _lvl.lvl;
      }
    }
    return (
      this.eventService.eventsClassList.find(
        (eventClass: any) => eventClass.tipo == event.tipo,
      )?.clase ?? 'default-event'
    );
  }

  getClassByEvent(event: any): string {
    return this.eventClasses[event.uuid_event] ?? 'default-event';
  }

  public loadEventsByDate() {
    this.eventService.getEventsByDateRange(
      '2026-05-10 00:00:00',
      '2026-05-10 23:59:59',
    );
  }

  public showFirstEvent() {
    this.events$.pipe(take(1)).subscribe((events) => {
      if (events && events.length > 0) {
        const firstEvent = events[0];
        this.eventService.scrollToEvent(firstEvent.uuid_event);
      }
    });
  }

  public showLastEvent() {
    this.events$.pipe(take(1)).subscribe((events) => {
      if (events && events.length > 0) {
        const lastEvent = events[events.length - 1];
        this.eventService.scrollToEvent(lastEvent.uuid_event);
      }
    });
  }

  async loadMore() {
    if (this.isLoadingMoreEvents || !this.canLoadMoreEvents) {
      return;
    }
    this.isLoadingMoreEvents = true;
    this.spinner.show('loadingEventList');

    try {
      /* Deprecated: Load more events
      if (this.startDate && this.endDate) {
        const start = this.startDate.toISOString();
        const end = this.endDate.toISOString();
        const hasMoreEvents = await this.eventService.loadMoreEvents(start, end);
        this.canLoadMoreEvents = hasMoreEvents;
      } else {
        */
      const hasMoreEvents = await this.eventService.loadMoreEvents();
      this.canLoadMoreEvents = hasMoreEvents;
      /*
      }
      */
    } catch (error) {
      console.error('Error al cargar más eventos:', error);
    } finally {
      this.isLoadingMoreEvents = false;
      this.spinner.hide('loadingEventList');
      this.cdr.detectChanges();
    }
  }

  toggleSearchPanel() {
    this.showSearchPanel = !this.showSearchPanel;
    if (this.showSearchPanel) {
      const now = new Date();
      this.maxSearchDate = now;
      const tenDaysAgo = new Date();
      tenDaysAgo.setDate(now.getDate() - 90);
      this.minSearchDate = tenDaysAgo;

      // If service hasn't been modified yet, use the "last event to 1 hour before" default
      if (!this.eventService.hasModifiedSearchDates) {
        let referenceDate = now;
        if (this.eventsTable.length > 0) {
          const oldestEvent = this.eventsTable[this.eventsTable.length - 1];
          const dateStr = oldestEvent.fecha_tracker.replace(/\//g, '-');
          referenceDate = new Date(dateStr);
        }

        this.searchEndDate = referenceDate;
        const oneHourBefore = new Date(
          referenceDate.getTime() - 60 * 60 * 1000,
        );
        this.searchStartDate = oneHourBefore;

        this.updateServiceDates();
      }
    }
  }

  updateServiceDates() {
    this.eventService.searchStartDate = this.searchStartDate;
    this.eventService.searchEndDate = this.searchEndDate;
    this.eventService.hasModifiedSearchDates = true;
    this.checkDateRange();
  }

  onSearchStartDateChange(newDate: Date) {
    if (!newDate || !this.searchEndDate) return;
    const diff = this.searchEndDate.getTime() - newDate.getTime();
    const oneDay = 24 * 60 * 60 * 1000;
    if (diff > oneDay || diff < 0) {
      this.showDateRangeWarning = true;
    } else {
      this.showDateRangeWarning = false;
    }
    this.updateServiceDates();
  }

  onSearchEndDateChange(newDate: Date) {
    if (!newDate || !this.searchStartDate) return;
    const diff = newDate.getTime() - this.searchStartDate.getTime();
    const oneDay = 24 * 60 * 60 * 1000;
    if (diff > oneDay || diff < 0) {
      this.showDateRangeWarning = true;
    } else {
      this.showDateRangeWarning = false;
    }
    this.updateServiceDates();
  }

  private checkDateRange() {
    if (!this.searchStartDate || !this.searchEndDate) return;
    const diff = Math.abs(
      this.searchEndDate.getTime() - this.searchStartDate.getTime(),
    );
    const oneDay = 24 * 60 * 60 * 1000;
    if (diff > oneDay + 1000) {
      // small margin
      this.showDateRangeWarning = true;
    } else {
      this.showDateRangeWarning = false;
    }
  }

  async searchEventsByDate() {
    if (!this.searchStartDate || !this.searchEndDate) {
      return;
    }

    const oneDay = 24 * 60 * 60 * 1000;
    const diff = this.searchEndDate.getTime() - this.searchStartDate.getTime();

    // Mayor a 24 horas o fecha fin menor a fecha inicio
    if (diff > oneDay || diff < 0) {
      this.showDateRangeWarning = true;
      return;
    }

    this.showDateRangeWarning = false;

    this.spinner.show('loadingEventList');

    try {
      const filterVehicles = this.selectedVehicles.map(
        (vehicle: any) => vehicle.IMEI,
      );
      const filterEvents = this.selectedEvent.map((event: any) => event.value);

      this.searchEndDate.setSeconds(0, 0);
      this.searchStartDate.setSeconds(0, 0);
      const start = this.formatDate(this.searchStartDate);
      const end = this.formatDate(this.searchEndDate);

      await this.eventService.getEventsByDateRange(
        start,
        end,
        filterVehicles,
        filterEvents,
      );

      this.showSearchPanel = false;
    } catch (error) {
      console.error('Error searching events:', error);
    } finally {
      this.spinner.hide('loadingEventList');
      this.cdr.detectChanges();
    }
  }

  private formatDate(date: Date): string {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }

  private async generateVehicleList() {
    this.vehiclesList = [];
    this.populateVehiclesList(this.vehicleService.vehicles);
    // this.loadOperations();
    if (this.selectedVehicles.length === 0) {
      this.selectedVehicles = [...this.vehiclesList];
    }
  }

  loadOperations() {
    this.operations = [];
    const sourceVehicles = this.vehicleService.vehicles;
    const addedOps = new Set();

    this.operations = sourceVehicles
      .filter((v) => v.idoperation != null)
      .map((v) => ({
        idoperation: v.idoperation,
        nameoperation: v.nameoperation || v.operation,
      })) // Handle potential naming diffs
      .filter((op) => {
        if (addedOps.has(op.idoperation)) return false;
        addedOps.add(op.idoperation);
        return true;
      })
      .sort((a, b) => (a.idoperation || 0) - (b.idoperation || 0));

    this.disabledOperation = false;
  }

  onChangeOperation() {
    this.selectedGroup = null;
    this.selectedConvoy = null;
    this.groups = [];
    this.convoys = [];
    this.selectedVehicles = [];
    this.vehiclesList = [];

    const operationId = this.selectedOperation;
    const sourceVehicles = this.vehicleService.vehicles.filter(
      (v) => v.idoperation === operationId,
    );

    if (this.selectedOperation == null) {
      this.populateVehiclesList(this.vehicleService.vehicles);
      this.selectedVehicles = [...this.vehiclesList];
    } else {
      this.populateVehiclesList(sourceVehicles);
      this.selectedVehicles = [...this.vehiclesList];
    }

    // Populate Groups
    const addedGroups = new Set();
    this.groups = sourceVehicles
      .filter((v) => v.idgrupo != null)
      .map((v) => ({ idgrupo: v.idgrupo, namegrupo: v.namegrupo || v.grupo }))
      .filter((g) => {
        if (addedGroups.has(g.idgrupo)) return false;
        addedGroups.add(g.idgrupo);
        return true;
      })
      .sort((a, b) => (a.idgrupo || 0) - (b.idgrupo || 0));

    this.disabledGroup = false;
    this.placeholderGroup = 'Seleccione un Grupo...';
    this.placeholderConvoy = 'Seleccione un Grupo Primero...';

    // Trigger filter update
    this.filterByVehicles();
  }

  onChangeGroup() {
    this.selectedConvoy = null;
    this.convoys = [];
    this.selectedVehicles = [];
    this.vehiclesList = [];

    const opId = this.selectedOperation;
    const groupId = this.selectedGroup;

    if (this.selectedGroup == null) {
      this.onChangeOperation();
      return;
    } else {
      const sourceVehicles = this.vehicleService.vehicles.filter(
        (v) => v.idoperation === opId && v.idgrupo === groupId,
      );

      this.populateVehiclesList(sourceVehicles);
      this.selectedVehicles = [...this.vehiclesList];

      const addedConvoys = new Set();
      this.convoys = sourceVehicles
        .filter((v) => v.idconvoy != null)
        .map((v) => ({ idconvoy: v.idconvoy, nameconvoy: v.nameconvoy }))
        .filter((c) => {
          if (addedConvoys.has(c.idconvoy)) return false;
          addedConvoys.add(c.idconvoy);
          return true;
        })
        .sort((a, b) => (a.idconvoy || 0) - (b.idconvoy || 0));

      this.disabledConvoy = false;
      this.placeholderConvoy = 'Seleccione un Convoy...';
      this.filterByVehicles();
    }
  }

  onChangeConvoy() {
    this.selectedVehicles = [];
    this.vehiclesList = [];

    const opId = this.selectedOperation;
    const groupId = this.selectedGroup;
    const convoyId = this.selectedConvoy;

    if (this.selectedConvoy == null) {
      this.onChangeGroup();
      return;
    } else {
      const sourceVehicles = this.vehicleService.vehicles.filter(
        (v) =>
          v.idoperation === opId &&
          v.idgrupo === groupId &&
          v.idconvoy === convoyId,
      );

      this.populateVehiclesList(sourceVehicles);
      this.selectedVehicles = [...this.vehiclesList];
      this.filterByVehicles();
    }
  }

  private populateVehiclesList(source: any[]) {
    this.vehiclesList = [];
    for (let vh of source) {
      const item: VehicleList = {
        id: vh.id!,
        plate_number: vh.plate_number!,
        IMEI: vh.IMEI!,
        cod_interno: vh.cod_interno!,
        name: (vh as any).name_old!,
        ...({
          idoperation: vh.idoperation,
          nameoperation: vh.operation,
          idgrupo: vh.idgrupo,
          namegrupo: vh.grupo,
          idconvoy: vh.idconvoy,
          nameconvoy: vh.nameconvoy,
        } as any),
      };
      this.vehiclesList.push(item);
    }
  }

  public setListOperators(): any {
    this.operators = [];
    return this.operatorService.listOperators;
  }

  // TODO: Esta funcion lo que realmente hace es filtrar los eventos por los vehiculos
  // y eventos seleccionados por lo tanto su nombre deberia ser filterByVehiclesAndEvents
  public async filterByVehicles() {
    this.eventService.filterWithVehiclesPublic(
      this.selectedVehicles.map((vehicle) => vehicle.IMEI),
    );
    // await this.eventService.setEventSelected(this.selectedEvent);
    if (this.selectedVehicles.length === 0 && this.selectedEvent.length === 0) {
      this.eventService.eventsFiltered = this.eventService.getData();
      this.noResults = false;
    } else {
      this.eventService.eventsFiltered = this.eventService
        .getData()
        .filter((event: any) => this.eventFilter(event));
      this.noResults = this.eventService.eventsFiltered.length === 0;
    }
    // this.eventService.setVehicleSelected(this.selectedVehicles);
  }

  public async changeTypeEvent() {
    // console.log("cambiando filtro de eventos ...... *****************+ ");
    // console.log('selectedEvent', this.selectedEvent);
    this.eventService.filterWithTypeEventPublic(this.selectedEvent);
    // await this.eventService.setEventSelected(this.selectedEvent);
    if (this.selectedEvent.length === 0 && this.selectedVehicles.length === 0) {
      this.eventService.eventsFiltered = this.eventService.getData();

      this.noResults = false;
    } else {
      this.eventService.getEventFilter(this.selectedEvent);
      this.eventService.eventsFiltered = this.eventService
        .getData()
        .filter((event: any) => {
          // console.log(" --- event: ",event);
          let result_filter = this.eventFilter(event);
          // console.log("result_filter",result_filter);
          return result_filter;
        });
      this.noResults = this.eventService.eventsFiltered.length === 0;
    }
  }
  /* Deprecated: Filter by date
  // public async filterByDate() {
  //   if (this.startDate && this.endDate) {
  //     const diffTime = Math.abs(this.endDate.getTime() - this.startDate.getTime());
  //     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  //     if (diffTime > (1000 * 60 * 60 * 24)) {
  //       this.customToastMessagess.addCustomToast({
  //         id: 'date-range-warn',
  //         severity: 'error',
  //         summary: 'Rango de fechas',
  //         detail: 'El rango de consulta no puede ser mayor a 24 horas.',
  //         data: {}
  //       });
  //       return;
  //     }

  //     this.spinner.show('loadingEventList');
  //     try {
  //       const start = this.startDate.toISOString();
  //       const end = this.endDate.toISOString();
  //       await this.eventService.getEventsByDateRange(start, end);
  //     } catch (error) {
  //       console.error('Error filtering by date:', error);
  //     } finally {
  //       this.spinner.hide('loadingEventList');
  //       this.cdr.detectChanges();
  //     }
  //   }
  // }
  */

  ngOnDestroy() {
    this.clearAllHighlightMarkers();
    if (this.eventService.activeEvent) {
      this.hideEvent(this.eventService.activeEvent);
    }
    if (this.lastMultimediaComponentRef) {
      this.lastMultimediaComponentRef.destroy();
    }

    // this.eventService.clearFilters();
    this.selectedVehicles = [];
    this.selectedEvent = [];
    // Limpiar el estado en el servicio
    this.reloadPageService.checkClosePanelEvents();
    this.mapAsideService.hide();
    this.subscription.unsubscribe();
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }
  clickDatosDebug(): void {
    this.eventSocketService.debug(this.imei_debug);
  }
  clickEndDeveloper(): void {
    this.eventService.eventDeveloperStatus = false;
    this.eventService.eventDeveloperCount = 0;
    this.data_debug = ['-', '-', '-', '-'];
  }
  clickEventPanel(): void {
    if (!this.isLoadingForm) {
      if (this.eventService.eventDeveloperCount > 5) {
        this.eventService.eventDeveloperStatus = true;
      } else {
        this.eventService.eventDeveloperCount++;
      }
      this.cdr.detectChanges();
    }
  }

  async loadFilterData() {
    if (!this.eventService.hasEventPanelBeenOpened) {
      this.eventService.hasEventPanelBeenOpened = true;
      await this.eventService.getAllEventsForTheFilter();
      this.eventService.filterLoaded = true;
    }
    this.tipoEvento = this.eventService.getFilters();
    //console.log('filtrosobtenidos', this.tipoEvento);
    this.eventService.showEventPanel();
    /* this.tipoEvento.unshift({ id: 0, option: 'Todos los Eventos', tipo: '' }); */
  }

  public addEvaluation(uuid: any) {
    let max = 10;
    this.uuid_evaluation.push(uuid);
    if (this.uuid_evaluation.length > max) this.uuid_evaluation.shift();
  }

  private auxDistante: { lat: number; lon: number; active: boolean } = {
    lat: 0,
    lon: 0,
    active: false,
  };

  private getDistance(lat1: number, lon1: number, lat2: number, lon2: number) {
    const R = 6371; // Radio de la Tierra en km
    const toRad = (degree: number) => degree * (Math.PI / 180);

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  // Método para limpiar todos los marcadores de resaltado
  private clearAllHighlightMarkers() {
    if (
      this.eventService.activeEvent &&
      this.eventService.activeEvent.highlightMarkers
    ) {
      this.eventService.activeEvent.highlightMarkers.forEach((marker: any) => {
        this.mapService.map.removeLayer(marker);
      });
      this.eventService.activeEvent.highlightMarkers = null;
    }

    this.eventService.getData().forEach((event: any) => {
      if (event.highlightMarkers) {
        event.highlightMarkers.forEach((marker: any) => {
          this.mapService.map.removeLayer(marker);
        });
        event.highlightMarkers = null;
      }
    });
  }

  showEvent(event: any) {
    // Limpiar todos los marcadores existentes antes de mostrar los nuevos
    if (this.isErrorEventEvaluated) {
      return;
    }

    this.clearAllHighlightMarkers();

    const objParams: any = {};
    /*
    antes de procesar parametros  string
    event-list.component.ts:130 despues de procesar parametros  object
    */
    // console.log("event",event);

    if (event.parametros && typeof event.parametros == 'string') {
      event.parametrosString = event.parametros;
      event.parametros.split('|').forEach((item: any) => {
        const [key, value] = item.split('=');
        objParams[key] = value;
      });
      //reemplazo el atributo parametros (string) con el objeto
      event.parametros = objParams;
    }

    if (this.eventService.activeEvent) {
      if (
        this.eventService.activeEvent.id == event.id &&
        event.layer.isPopupOpen()
      ) {
        return;
      }
      // ESTO SE DEBE DESCOMENTAR
      /* this.eventService.activeEvent.layer.closePopup();
      this.eventService.activeEvent.layer.unbindPopup(); */
      /* this.eventService.activeEvent.layer.off(); */

      // this.mapAsideService.hide();

      this.eventService.activeEvent.layer.off();
      // condicional de que si es llamado por reload no ejecutar esto
      this.hideEvent(this.eventService.activeEvent);
    }

    // console.log('EVENT VIEWED', event.viewed);

    if (!event.viewed) {
      event.viewed = true;
      // this.markAsRead(event.evento_id);
    }
    this.eventService.activeEvent = event;
    this.cdr.detectChanges();

    var eventClass: any = this.eventService.eventsClassList.filter(
      (eventClass: any) => eventClass.tipo == event.tipo,
    );
    eventClass = eventClass.length > 0 ? eventClass[0].clase : 'default-event';
    //console.log(' ############ eventclass: ', eventClass);
    const targetLatLng = event.layer.getLatLng();

    const varColor = this.getClassByEvent(event);
    // console.log('varColor', varColor);

    const pulseIcon = L.divIcon({
      className: 'pulse-icon',
      html: `
        <div class="pulse-marker ${varColor}">
          <style>
            .pulse-marker {
              width: 20px;
              height: 20px;
              background: transparent;
              border-radius: 50%;
              position: relative;
              margin-top: 16px;
            }
            .pulse-marker:before {
              content: '';
              position: absolute;
              width: 100%;
              height: 100%;
              background: var(--event-main-color, #2196f3);
              border-radius: 50%;
              animation: pulse 1.5s ease-out infinite;
              z-index: -1;
            }
            @keyframes pulse {
              0% {
                transform: scale(1);
                opacity: 0.5;
              }
              100% {
                transform: scale(3);
                opacity: 0;
              }
            }
          </style>
        </div>
      `,
      iconSize: [20, 20],
      iconAnchor: [10, 10],
    });

    const arrowIcon = L.divIcon({
      className: 'arrow-icon',
      html: `
        <div class="arrow-marker ${varColor}">
          <style>
            .arrow-marker {
              width: 0;
              height: 0;
              border-left: 15px solid transparent;
              border-right: 15px solid transparent;
              border-top: 25px solid var(--event-main-color, #2196f3);
              transform-origin: bottom center;
              animation: bounce 1s infinite;
              margin-top: -24px;
            }
            @keyframes bounce {
              0%, 100% {
                transform: translateY(-10px);
              }
              50% {
                transform: translateY(0);
              }
            }
          </style>
        </div>
      `,
      iconSize: [30, 25],
      iconAnchor: [15, 0],
    });

    const pulseMarker = L.marker([targetLatLng.lat, targetLatLng.lng], {
      icon: pulseIcon,
      zIndexOffset: -1000,
    }).addTo(this.mapService.map);

    const arrowMarker = L.marker([targetLatLng.lat, targetLatLng.lng], {
      icon: arrowIcon,
      zIndexOffset: 1000,
      interactive: false,
      keyboard: false,
      riseOnHover: false,
    }).addTo(this.mapService.map);
    event.highlightMarkers = [arrowMarker, pulseMarker];

    if (this.auxDistante.active) {
      const distance = this.getDistance(
        this.auxDistante.lat,
        this.auxDistante.lon,
        targetLatLng.lat,
        targetLatLng.lng,
      );
      if (distance <= 1) {
        this.mapService.map.flyTo([targetLatLng.lat, targetLatLng.lng], 19, {
          animate: true,
          duration: 0.5,
          easeLinearity: 1,
        });
        this.mapService.map.invalidateSize();
      } else {
        this.mapService.map.fitBounds([[targetLatLng.lat, targetLatLng.lng]], {
          padding: [50, 50],
        });
      }
    } else {
      this.auxDistante.active = true;
      this.mapService.map.fitBounds([[targetLatLng.lat, targetLatLng.lng]], {
        padding: [50, 50],
      });
    }
    this.auxDistante.lat = targetLatLng.lat;
    this.auxDistante.lon = targetLatLng.lng;

    // console.log("eventlayer",event.layer)
    //no-rostro
    //infraccion-geocerca

    if (this.lastMultimediaComponentRef) {
      this.lastMultimediaComponentRef.destroy();
    }
    const componentRef = this.addMultimediaComponentAsideMap(event);
    this.lastMultimediaComponentRef = componentRef;
    this.mapAsideService.show('events', { ...event, componentRef });

    event.layer.on('click', () => {
      this.mapAsideService.show('events', { ...event, componentRef });
      this.mapService.map.setView(event.layer.getLatLng(), 19);
    });
    event.layer.addTo(this.mapService.map);

    // Auto-limpiar los marcadores después de 4 segundos
    /* setTimeout(() => {
      if (event.highlightMarkers) {
        event.highlightMarkers.forEach((marker: any) => {
          this.mapService.map.removeLayer(marker);
        });
        event.highlightMarkers = null;
      }
    }, 4000); */

    // ESTO SE DEBE DESCOMENTAR
    /* event.layer.bindPopup(getContentPopup(event), {
      className: eventClass,
      minWidth: 250,
      maxWidth: 350,
    }); */
    // event.layer.on('click', () => {
    // this.mapAsideService.show('events', { ...event, componentRef });
    /* this.addMultimediaComponent(event);
      this.addDVRGalleryComponent(event); */
    //   });
    /* event.layer.addTo(this.mapService.map).openPopup(); */
    /* this.addDVRGalleryComponent(event);
    this.addMultimediaComponent(event); */
  }

  addDVRGalleryComponent(event: any) {
    try {
      const factory = this.resolver.resolveComponentFactory(
        DvrGalleryComponent!,
      );
      const componentRef = this.container.createComponent(factory);
      componentRef.instance.event = event;
      const container = document.getElementById(
        'dvrgallery-' + event.uuid_event,
      )!;
      container.innerHTML = '';
      container.appendChild(componentRef.location.nativeElement);
      // console.log('COMPONENETE CERADO: ', componentRef);
      componentRef.changeDetectorRef.detectChanges();
      this.appRef.tick();
    } catch (error) {
      // console.log('Saint', error);
    }
  }

  addMultimediaComponent(event: any) {
    if (
      event.parametros &&
      event.parametros.gps == 'cipia' &&
      (event.parametros.has_video != '0' || event.parametros.has_image != '0')
    ) {
      try {
        const factory = this.resolver.resolveComponentFactory(
          SliderMultimediaComponent!,
        );
        const componentRef: ComponentRef<any> =
          this.container.createComponent(factory);

        const params: any = {
          event: event!,
          rowSelected: this.currentRowSelected!,
          driver:
            this.vehicleService.vehicles.find((vh) => vh.IMEI == event.imei)
              ?.namedriver ?? '',
          showFooter: false,
          showMultimediaFirst: true,
          showMultimedias: false,
          hasMultimedia: true,
          showTitle: false,
        };
        //console.log(
        //  'eventRowSelected event list',
        //  event,
        //  this.currentRowSelected
        //);

        Object.keys(params).forEach((key) => {
          componentRef.instance[key] = params[key];
        });
        const divContainer = document.getElementById(
          'multimedia-' + event.uuid_event,
        )!;

        divContainer.innerHTML = '';
        divContainer.appendChild(componentRef.location.nativeElement); // Agrega un componente hijo
        // this.appRef.attachView(componentRef.hostView); // Adjunta la vista del componente
        componentRef.changeDetectorRef.detectChanges(); // Forzar la detección de cambios
        this.appRef.tick(); // Forzar la detección de cambios en toda la aplicación
      } catch (error) {
        // console.log('SlideMultimediaComponent: inicialización fallida', error);
      }
    }
  }

  addMultimediaComponentAsideMap(event: any): any {
    if (
      event.parametros?.gps === 'cipia' &&
      (event.parametros.has_video !== '0' ||
        event.parametros.has_image !== '0' ||
        this.eventService.videoDemandInEvents[event.evento])
    ) {
      try {
        const factory = this.resolver.resolveComponentFactory(
          SliderMultimediaComponent!,
        );
        const componentRef: ComponentRef<any> =
          this.container.createComponent(factory);

        const params: any = {
          event: event!,
          rowSelected: this.currentRowSelected!,
          driver:
            this.vehicleService.vehicles.find((vh) => vh.IMEI == event.imei)
              ?.namedriver ?? '',
          showFooter: false,
          showMultimediaFirst: true,
          showMultimedias: false,
          hasMultimedia: true,
          showTitle: false,
        };
        //console.log(
        //  'eventRowSelected event list',
        //  event,
        //  this.currentRowSelected
        //);

        Object.keys(params).forEach((key) => {
          componentRef.instance[key] = params[key];
        });
        return componentRef;
      } catch (error) {
        // console.log('SlideMultimediaComponent: inicialización fallida', error);
      }
    } else {
      return null;
    }
  }

  public hideEvent(event: any) {
    this.mapService.map.removeLayer(event.layer);
    this.eventService.activeEvent = false;
  }

  private markAsRead(event_id: any) {
    //console.log('desde event list Marking ' + event_id + ' as read...');
    //this.eventService.decreaseUnreadCounter();
    this.eventService.updateUnreadCounter();
    this.http
      .get<any>(
        environment.apiUrl + '/api/event-user/mark-as-viewed/' + event_id,
      )
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (data) => {
          //console.log('desde event list Mark ' + event_id + ' as read Success? : ', data.success);
        },
        error: () => {
          //console.log(event_id + ': Hubo un error al marcar como leído');
        },
      });
  }
  public async switchEventOnMap(event: any, currentRow?: HTMLElement) {
    /*
    this.waitTimeService.startTime({
      id: event.uuid_event,
      start: Date.now(),
      itemsId: [],
      end: [],
      event: [],
      type: [],
      size: [],
      duration: [],
    });
    this.currentRowSelected = currentRow!; */
    // console.log('EVENTO: ', event);
    // console.log('eventList:: FILTER TEST EVENT:', event);
    // console.log("this.eventService.activeEvent.id",this.eventService.activeEvent.id);
    // if(event.event_id == this.eventService.activeEvent.id){

    //if (false) {
    // this.hideEvent(this.eventService.activeEvent);
    //} else {
    //await this.switchTypeEventFilter(event.tipo);
    // currentRow?.classList?.add('watched-event');
    /* document
        .getElementById(event.uuid_event)
        ?.classList?.add('watched-event'); */

    //console.log('Mostrando evento con ID: ', event.evento_id);
    // let reference = await this.eventService.getReference(
    //   event.latitud,
    //   event.longitud
    // );

    /*  let e = { ...event };
      this.eventService.getReference(e.latitud, e.longitud).then((_) => {
        event.referencia = { ..._ }.referencia; */
    /* console.log('EVENTO COMPLETO: ', e);
        console.log('SUBMIT', this.submitting);

        console.log('CRITERIOS: ', this.evaluation_criteria_filter);
        console.log('EVENTS EVALUATED: ', this.eventsEvaluated);
        console.log('LOADING: ', this.loading_evaluation);
        console.log('EVALUATION CRITERIO: ', this.evaluation_criteria); */
    /*   this.showEvent({
          ...event,
          evaluation_criteria_filter: this.evaluation_criteria_filter,
          operators: this.operatorService.listOperators,
        });
      }); */

    // let buffer = this.referenceService.getBuffer();
    // if (buffer[event.id] == undefined) {
    //   this.referenceService.searchReferenceEvent(event);
    // } else {
    //   event.referencia = buffer[event.id];
    //   this.showEvent(event);
    // }
    // this.referenceService.searchReferenceEvent(event);
    // event.referencia = "Cargando ...";
    // this.showEvent(event);
    //}
    if (currentRow) {
      this.currentRowSelected = currentRow;
    }
    if (!this.isLoadingForm) {
      this.eventSelection$.next({ event, currentRow });
      this.rowExpansion$.next({ data: event });
    }
  }

  public checkPopupExist() {
    return document.querySelectorAll('.leaflet-popup').length > 0;
  }

  /* Filtro anterior de  ingreso placa */

  // public searchByPlate() {
  //   //if(this.selectedEvent === null && this.placa == ''){
  //   if (this.selectedEvent.length == 0 && this.placa == '') {
  //     this.eventService.eventsFiltered = this.eventService.getData();
  //     this.noResults = false;
  //   } else {
  //     this.eventService.eventsFiltered = this.eventService
  //       .getData()
  //       .filter((event: any) => {
  //         // console.log('this.eventFilter(event)', this.eventFilter(event));
  //         return this.eventFilter(event);
  //       });
  //     this.noResults = this.eventService.eventsFiltered.length == 0;
  //   }
  //   //console.log(this.eventService.eventsFiltered);
  //   //console.log(this.noResults);
  // }

  public async switchTypeEventFilter(event_slug: string): Promise<void> {
    // console.log('FILTER TEST Switch Slug:', event_slug);
    // if (event_slug == 'conductor-distraido-360') {
    //   this.filterCriteriaByEvent('DISTRACCIÓN');
    // } else if (event_slug == 'cinturon-desabrochado-360') {
    //   this.filterCriteriaByEvent('CINTURÓN');
    // } else if (event_slug == 'conductor-fumando-360') {
    //   this.filterCriteriaByEvent('FUMAR');
    // } else {
    //   this.filterCriteriaByEvent('ALL');
    //   // PARA ESTO Y PARA CUALQUIER OTRO
    //   // 'conductor-adormitado-360',
    //   // 'conductor-somnoliento-360',
    //   // 'posible-fatiga',
    // }
    const eventSlug: { [key: string]: string } = {
      'conductor-distraido-360': 'DISTRACCIÓN DETECTADA',
      'cinturon-desabrochado-360': 'CINTURÓN NO DETECTADO',
      'conductor-fumando-360': 'CIGARRO DETECTADO',
      'uso-de-celular-360': 'CELULAR DETECTADO',
      'conductor-adormitado-360': 'CONDUCTOR ADORMITADO',
      'conductor-somnoliento-360': 'CONDUCTOR SOMNOLIENTO',
      'exceso-velocidad': 'EXCESO DE VELOCIDAD',
      'infraccion-geocerca': 'EXCESO DE VELOCIDAD',
      'infraccion-geocerca-direccion': 'EXCESO DE VELOCIDAD',
      'exceso-velocidad-geocerca-direccion': 'EXCESO DE VELOCIDAD',
    };
    //this.evaluationCriteriaService.getCriteriaBySlug(event_slug);
    this.evaluation_criteria_filter =
      this.evaluationCriteriaService.getOptionBySlug(event_slug);
    //this.filterCriteriaByEvent(eventSlug[event_slug] ?? 'ALL');
  }
  public filterCriteriaByEvent(event_filter: string): void {
    // console.log('FILTER TEST event_filter:', event_filter);
    if (event_filter == 'ALL') {
      this.evaluation_criteria_filter = this.evaluation_criteria.slice(0, 2);
    } else {
      // Filtrar los elementos de evaluation_criteria que coincidan con el evento seleccionado
    }
    // console.log('FILTER TEST CRITERIOS:', this.evaluation_criteria);
    // console.log('FILTER TEST CRITERIOS:', this.evaluation_criteria_filter);
  }

  /*--Filtro para socket --*/
  /**
   * @deprecated
   *
   */
  /* Deprecated: Filter by date
  public async filterByDate(): Promise<void> {
     if (this.startDate && this.endDate) {
       if (this.startDate > this.endDate) {
         this.toastService.emitToastMessage({
           severity: 'error',
           summary: 'Error',
           detail: 'La fecha de inicio no puede ser mayor a la fecha de fin',
         });
         return;
       }

       // Validar rango Maximo de 24 horas
       const diffTime = Math.abs(this.endDate.getTime() - this.startDate.getTime());
       if (diffTime > 86400000) { // 24 * 60 * 60 * 1000
         this.toastService.emitToastMessage({
           severity: 'warn',
           summary: 'Atención',
           detail: 'El rango de fechas no puede ser mayor a 24 horas.',
         });
         return;
       }

       this.spinner.show('loadingEventList');
       try {
         // Actualizamos el contexto del filtro para lo que venga por socket
         this.eventService.filterByDatePublic(this.startDate, this.endDate);

         // Traemos la data histórica del backend
         const start = this.startDate.toISOString();
         const end = this.endDate.toISOString();
         await this.eventService.getEventsByDateRange(start, end);
       } catch (error) {
         console.error('Error filtering by date:', error);
       } finally {
         this.spinner.hide('loadingEventList');
         this.cdr.detectChanges();
       }

     } else if (!this.startDate && !this.endDate) {
       this.eventService.filterByDatePublic(null, null);
     }
   }
   */

  // private eventFilter(event: any) {
  //   // console.log("eventFilter filter ===> ");
  //   // console.log("event",event);
  //   // console.log("tipo select",event.tipo +"=="+ this.selectedEvent);
  //   const eventsTypesSelected: string[] = this.selectedEvent.map(
  //     (event: any) => {
  //       return event.value;
  //     }
  //   );
  //   const vehicle = this.vehicleService.vehicles.find(
  //     (vh) => vh.IMEI == event.imei
  //   );
  //   if (vehicle != undefined) {
  //     let aux_imei = vehicle.IMEI ?? '';
  //     let aux_cod = vehicle.cod_interno ?? '';
  //     let aux = event.nombre_objeto + aux_imei + aux_cod;
  //     return (
  //       (aux
  //         .toString()
  //         .trim()
  //         .toLowerCase()
  //         .match(this.placa.trim().toLowerCase()) ||
  //         this.placa == '') &&
  //       (eventsTypesSelected.includes(event.tipo) ||
  //         this.selectedEvent.length == 0)
  //     );
  //   } else {
  //     return false;
  //   }
  // }

  private eventFilter(event: any) {
    const vehiclesSelected: number[] = this.selectedVehicles.map(
      (vehicle: VehicleList) => vehicle.id,
    );

    const eventsTypesSelected: string[] = this.selectedEvent.map(
      (event: any) => {
        return event.value;
      },
    );

    const vehicle = this.vehicleService.vehicles.find(
      (vh) => vh.IMEI == event.imei,
    );

    if (vehicle != undefined) {
      return (
        (vehiclesSelected.includes(vehicle.id!) ||
          this.selectedVehicles.length == 0) &&
        (eventsTypesSelected.includes(event.evento) ||
          this.selectedEvent.length == 0)
      );
    } else {
      return false;
    }
  }

  public isRegisterEvent: boolean = false;
  public valueInputsDisabled: ValueInputsDisabled | null = null;

  rowExpandend(event: any) {
    // console.log('########## uuid_event ', event.data.uuid_event);
    /*     const testing = { ...event.data };
    console.log('TESTING: ', testing);
    console.log('DATA: ', event.data); */

    /* if (event.data) {
      this.expandedRows[event.data.uuid_event] =
        !this.expandedRows[event.data.uuid_event];
    }
    this.loading_evaluation = true;
    this.display_dialog_event = true;
    this.display_dialog_content_event = true;
    this.isRegisterEvent = false;
    this.cdr.detectChanges();

    if (event.data.uuid_event) {
      this.eventService
        .getEvaluations(event.data.uuid_event)
        .then((evaluations) => { */
    //console.log('exito al buscar evaluation :', evaluations);

    /*     if (evaluations.length > 0) {
            let auxEvent = this.eventService.eventsFiltered.find(
              (ev: any) => ev.uuid_event == event.data.uuid_event
            );
            auxEvent.evaluations = evaluations as Evaluation[];
            auxEvent.evaluated = 1;
            this.isRegisterEvent = evaluations[0].id !== undefined;
            this.valueInputsDisabled = {
              criteria_name:
                evaluations[0].criterio_evaluacion || 'No hay criterios',
              url_video: evaluations[0].identificacion_video,
              calification: evaluations[0].valoracion_evento.toString(),
              observation: evaluations[0].observacion_evaluacion,
              operator_name: evaluations[0].operador_monitoreo,
              comunication: evaluations[0].has_radio_communication,
            };
          }
        })
        .finally(() => {
          this.loading_evaluation = false; */
    // emitir evento
    /*      this.mapAsideService.setValueAuxDisabled(
            this.isRegisterEvent,
            this.valueInputsDisabled
          );
          this.cdr.detectChanges();
        });
    } else {
      this.loading_evaluation = false;
      this.display_dialog_event = false;
      this.mapAsideService.setValueAuxDisabled(
        this.isRegisterEvent,
        this.valueInputsDisabled
      ); */
    // emitir evento
    /*
      this.cdr.detectChanges();
    } */
    if (!this.isLoadingForm) {
      this.rowExpansion$.next(event);
    }
  }
  submitSendEvaluationByWhatsapp(T: boolean) {
    this.sendEvaluationByWhatsapp = T;
  }
  submitSendExternal(T: boolean) {
    this.sendExternal = T;
  }

  submitEvaluation(
    evaluation: Evaluation,
    event: Alert | any,
    currentRow: HTMLElement,
  ) {
    evaluation.arrival_time = this.waitTimeService.getTime(event.uuid_event)!;
    evaluation.operador_monitoreo?.replace(/\s+/g, '').trim();
    if (evaluation.operador_monitoreo?.trim() == '') {
      this.customToastMessagess.addCustomToast({
        id: evaluation.uuid_event!.toString(),
        severity: 'warn',
        summary: `Alerta: ${event.evaluations![0].tipo_evento}`,
        detail: `Ingrese o seleccione el nombre del operador`,
        data: {
          unit: `Unidad: ${event.nombre_objeto}`,
          datetime: `Fecha: ${event.fecha_tracker}`,
          dataEvent: event,
          dataHTML: this.currentRowSelected,
        },
        sticky: false,
        closable: false,
      });
      return;
    }
    // if (
    //   evaluation.is_confirmed == true &&
    //   evaluation.valoracion_evento == '0'
    // ) {
    //   this.customToastMessagess.addCustomToast({
    //     id: evaluation.uuid_event!.toString(),
    //     severity: 'warn',
    //     summary: `Alerta: ${event.evaluations![0].tipo_evento}`,
    //     detail: `Debe valorar la precisión del evento (1-5 estrellas)`,
    //     data: {
    //       unit: `Unidad: ${event.nombre_objeto}`,
    //       datetime: `Fecha: ${event.fecha_tracker}`,
    //       dataEvent: event,
    //       dataHTML: this.currentRowSelected,
    //     },
    //     sticky: false,
    //     closable: false,
    //   });
    //   return;
    // }
    /* if (!evaluation.is_confirmed) {
      console.log('Ingreso a esta condicion??????');
      console.log('Ingreso a esta condicion??????');
      console.log('Ingreso a esta condicion??????');
      evaluation.valoracion_evento = '0';
      evaluation.identificacion_video = '';
    } */
    if (
      (typeof evaluation.criterio_evaluacion !== 'string' ||
        evaluation.criterio_evaluacion.trim() === '') &&
      (typeof evaluation.observacion_evaluacion !== 'string' ||
        evaluation.observacion_evaluacion.trim() === '')
    ) {
      this.customToastMessagess.addCustomToast({
        id: evaluation.uuid_event!.toString(),
        severity: 'warn',
        summary: `Alerta: ${event.name}`,
        detail: `Seleccione un criterio de evaluación o ingrese una observación`,
        data: {
          unit: `Unidad: ${event.nombre_objeto}`,
          datetime: `Fecha: ${event.fecha_tracker}`,
          dataEvent: event,
          dataHTML: this.currentRowSelected,
        },
        sticky: false,
        closable: false,
      });
      return;
    }
    this.customToastMessagess.addCustomToast({
      id: evaluation.uuid_event!.toString(),
      severity: 'info',
      summary: `${event.evaluations![0].tipo_evento}: Guardando`,
      detail: ``,
      data: {
        unit: `Unidad: ${event.nombre_objeto}`,
        datetime: `Fecha: ${event.fecha_tracker}`,
        dataEvent: event,
        dataHTML: this.currentRowSelected,
      },
      sticky: false,
      closable: false,
    });

    this.eventsEvaluated++;
    this.expandedRows = {};
    this.submitting = true;
    const auxTest = evaluation as any;
    const criterion_id = auxTest.criterio_id;
    this.eventService
      .saveEvaluations({ ...evaluation, criterion_id: criterion_id })
      .then(async (response) => {
        let realEvent = this.eventService.eventsFiltered.find(
          (event) => event.uuid_event == evaluation.uuid_event,
        );
        realEvent.evaluations = response[0] as Evaluation[];
        realEvent.evaluated += 1;

        this.driverIdentificationService.close();
        this.customToastMessagess.updateCustomToastById({
          id: evaluation.uuid_event!.toString(),
          severity: 'success',
          summary: `${event.name}: Guardado`,
          detail: ``,
          data: {
            unit: `Unidad: ${event.nombre_objeto}`,
            datetime: `Fecha: ${event.fecha_tracker}`,
          },
          sticky: false,
          closable: false,
        });

        const isRegisterEvent = response[0].id !== undefined;
        const valueInputsDisabled = {
          criteria_name: response[0].criterio_evaluacion || 'No hay criterios',
          url_video: response[0].identificacion_video,
          calification: response[0].valoracion_evento.toString(),
          observation: response[0].observacion_evaluacion,
          operator_name: response[0].operador_monitoreo,
          comunication: response[0].has_radio_communication,
        };
        this.mapAsideService.setValueAuxDisabled(
          isRegisterEvent,
          valueInputsDisabled,
        );

        if (event.originPopup && event.originPopup === true) {
          this.mapAsideService.markEventAsEvaluated();
        }

        this.isRegisterEvent = isRegisterEvent;
        this.valueInputsDisabled = valueInputsDisabled;
        this.mapAsideService.setIsLoading(false);

        if (typeof response[1] === 'number' && response[1] == 0) {
          if (typeof response[0] === 'object') {
            let retryEvaluation: Evaluation = response[0];
            this.eventService
              .updateEvaluatedToEvaluations(retryEvaluation)
              .then((r) => {})
              .catch((c) => {})
              .finally(() => {});
          }
        }

        if (this.sendEvaluationByWhatsapp) {
          this.whatsappService
            .sendWhatsAppAlertEvaluated(evaluation, event)
            .then((r) => {
              this.whatsappService.sendResponseOfPostWhastApp({
                usuario_id: evaluation.usuario_id!.toString(),
                uuid_event: evaluation.uuid_event!.toString(),
                ws_json: JSON.stringify(r),
              });
              this.mapAsideService.setMessagesSentByWhatsApp(r);
              this.cdr.detectChanges();
            });
        }
        if (this.sendExternal) {
          let e: EventTx = {
            evento_id: event.evento_id ?? 0,
            usuario_id: event.usuario_id ?? 0,
            descripcion_evento: event.tipo ?? '',
            tipo: event.tipo ?? '',
            sistema_notificacion: '',
            tracker_imei: event.imei ?? 0,
            nombre_objeto: event.nombre_objeto ?? '',
            fecha_servidor: event.fecha_servidor ?? '',
            fecha_tracker: event.fecha_tracker ?? '',
            latitud: parseFloat(event.latitud) ?? 0,
            longitud: parseFloat(event.longitud) ?? 0,
            altitud: parseFloat(event.altitud) ?? 0,
            angulo: parseFloat(event.angulo) ?? 0,
            velocidad: parseFloat(event.velocidad) ?? 0,
            parametros:
              Object.entries(event.parametros)
                .map(([key, value]) => `${key}=${value}`)
                .join('|')
                .replace('=undefined', '') ?? '',
            fecha_minuto: event.fecha_tracker ?? '',
            name: event.name ?? '',
            nombre: event.nombre ?? '',
            mensaje_alerta: event.mensaje_alerta ?? '',
            tiempo_limite: event.tiempo_limite ?? '',
            nombre_zona: event.nombre_zona ?? '',
            id_zona: event.id ?? 0,
            int_mant_ultimo_mantenimiento:
              event.int_mant_ultimo_mantenimiento ?? 0,
            int_mant_horas_transcurridas:
              event.int_mant_horas_transcurridas ?? 0,
            int_mant_horas_restantes: event.int_mant_horas_restantes ?? 0,
            int_mant_anticipado: event.int_mant_anticipado ?? 0,
            int_mant_programado: event.int_mant_programado ?? 0,
            int_mant_odometro: event.int_mant_odometro ?? 0,
            dat_correctivo_ini: event.dat_correctivo_ini ?? '',
            dat_correctivo_fin: event.dat_correctivo_fin ?? '',
            velocidad_limite: parseFloat(event.velocidad_limite) ?? 0,
            tiempo_limite_infraccion:
              parseFloat(event.tiempo_limite_infraccion) ?? 0,
            viewed: event.viewed ?? false,
            driver_id: parseFloat(event.driver_id) ?? 0,
            event_group: '',
            users: '',
            bol_evaluation: event.bol_evaluation ?? false,
            type_evaluation: event.type_evaluation ?? '',
            uuid_event: event.uuid_event ?? '',
            evaluation: evaluation,
            userIds: [968],
          };
          this.eventSocketService.externalEmit(e);
        }

        this.sendEvaluationByWhatsapp = false;
        this.display_dialog_event = true;
        this.addEvaluation(realEvent.uuid_event);
        this.eventSocketService.evaluationEmit({
          id: realEvent.id,
          uuid: realEvent.uuid_event,
        });
        this.eventsEvaluated > 0 ? this.eventsEvaluated-- : null;

        let hasAccess = await this.permissionService.hasPermission(
          'validate_event_driver',
        );
        if (hasAccess) {
          realEvent.driver_id = response[0].driver_id;
          event.driver_id = response[0].driver_id;
          this.mapAsideService.show('events', { ...event });

          // this.showEvent(event);

          // this.eventSelection$.next({
          //   event,
          //   currentRow: this.currentRowSelected,
          // });
          this.cdr.detectChanges();
        }
      })
      .catch((error) => {
        var errorMessage = `Error desconocido`;
        var typeError = 'unknown';
        var typeServerity = 'error';
        var summaryError = `Error!: ${event.name}`;
        if (
          new Date(event.fecha_tracker!) <
          new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
        ) {
          errorMessage = `El tiempo de evaluacion expirado`;
          typeError = 'time';
          this.mapAsideService.setIsLoading(false);
        }

        if (
          error.error.messages.includes(
            'duplicate key value violates unique constraint',
          )
        ) {
          typeError = 'duplicate';
          errorMessage = `El evento ya ha sido evaluado`;
          this.isErrorEventEvaluated = true;
          this.eventSelection$.next({
            event,
            currentRow: this.currentRowSelected,
          });
          this.mapAsideService.setIsLoading(false);
          this.cdr.detectChanges();
        }
        this.customToastMessagess.updateCustomToastById({
          id: evaluation.uuid_event!.toString(),
          severity: typeServerity,
          summary: summaryError,
          detail: `${errorMessage}`,
          data: {
            type: typeError,
            dataEvent: event,
            error: errorMessage,
            dataHTML: this.currentRowSelected,
            unit: `Unidad: ${event.nombre_objeto}`,
            datetime: `Fecha: ${event.fecha_tracker}`,
            nowTime: this.nowDateTime(),
            rawError: error.error.messages.toString(),
          },
          sticky: typeServerity == 'success' ? false : true,
          closable: false,
        });
        this.eventsEvaluated > 0 ? this.eventsEvaluated-- : null;
      })
      .finally(() => {
        this.submitting = false;
        this.mapAsideService.setIsLoading(false);
      });
  }
  nowDateTime(): string {
    const now = new Date();
    const AAAA = now.getFullYear();
    const MM = now.getMonth() + 1; // Los meses comienzan desde 0, por lo que se suma 1
    const DD = now.getDate();
    const hh = now.getHours();
    const mm = now.getMinutes();
    const ss = now.getSeconds();
    // console.log(`iog: A/M/D h/m/s _${AAAA}${MM}${DD}_${hh}.${mm}.${ss}_`);
    return `${AAAA}/${MM}/${DD} ${hh}:${mm}:${ss}`;
  }
  clearEvaluation(evaluation: Evaluation) {
    //console.log("evaluation to clean", evaluation);

    if (!evaluation.id) {
      evaluation.criterio_evaluacion = '';
      evaluation.identificacion_video = '';
      evaluation.observacion_evaluacion = '';
      evaluation.operador_monitoreo = '';
      evaluation.valoracion_evento = '0';
      evaluation.senales_posible_fatiga = false;
      evaluation.is_confirmed = false;
    }
  }

  /* // Deprecate : Funcion que "no se usa?"
  criteriaSelected(event: any, evaluation: Evaluation) {
    evaluation.senales_posible_fatiga = false;
    this.evaluation_criteria[0].items.forEach((criteria) => {
      if (criteria.value == event.value) {
        evaluation.senales_posible_fatiga = true;
      }
    });
  }
  */

  closeEvaluationExpanded(evaluation: Evaluation) {
    this.clearEvaluation(evaluation);
    this.expandedRows = {};
  }

  /* // Añadido: Guarda el filtro seleccionado en el localStorage
  private saveFilterToLocalStorage(filter: string): void {
    localStorage.setItem('filter', filter);
  }

  // Añadido: Recupera el filtro almacenado en el localStorage
  private getFilterFromLocalStorage(): string {
    return localStorage.getItem('filter') || '';
  } */
}
